import { render, staticRenderFns } from "./abstract_consultation_detail.vue?vue&type=template&id=39e9add1&scoped=true"
import script from "./abstract_consultation_detail.vue?vue&type=script&lang=js"
export * from "./abstract_consultation_detail.vue?vue&type=script&lang=js"
import style0 from "./abstract_consultation_detail.vue?vue&type=style&index=0&id=39e9add1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9add1",
  null
  
)

export default component.exports